import { createReducer, on } from '@ngrx/store';

import { RenewActionsUnion } from '@ren/main/state/actions/renew.actions';
import { RenewActions } from '@ren/main/state/actions';

import { KeyValueDict } from '@global/infrastructure/interfaces/key-value-dict';


export interface RenewalState {
  isDisplayProgressBar: boolean;
  isReviewSelected: boolean;
  isQuoted: boolean;
  isNewVersionCreated: boolean;
  isPolicyBoundRenewal: boolean;
  renewalStartDate: Date;
  policyChangeSelection: {
    options: KeyValueDict<boolean>;
  };
  policyChangeSelectionLockedStatus: {
    yourCar: boolean;
    yourRegistration: boolean;
    yourDrivers: boolean;
    yourMileage: boolean;
    yourVehicleUsage: boolean;
    yourAddresses: boolean;
    whereIParkMyCar: boolean;
    yourDetails: boolean;
  };
}

export const initialState: RenewalState = {
  isDisplayProgressBar: false,
  isReviewSelected: true,
  isQuoted: false,
  isNewVersionCreated: false,
  isPolicyBoundRenewal: false,
  renewalStartDate: null,
  policyChangeSelection: {
    options: null
  },
  policyChangeSelectionLockedStatus: null
};

export const renewalReducer = createReducer(
  initialState,
  on(RenewActions.showProgressBar, (state, {isDisplayProgressBar}) => ({...state, isDisplayProgressBar})),
  on(RenewActions.updatePolicyChangeOptions, (state, {options}) => ({
    ...state,
    policyChangeSelection: {...state.policyChangeSelection, options}
  })),
  on(RenewActions.updateQuotedStatus, updateQuotedStatus),
  on(RenewActions.resetPolicySelections, state => ({...state, policyChangeSelection: {options: null}})),
  on(RenewActions.updateNewVersionStatus, (state, {isNewVersionCreated}) => ({...state, isNewVersionCreated})),
  on(RenewActions.updatePolicyBoundRenewal, (state, {isPolicyBoundRenewal}) => ({...state, isPolicyBoundRenewal}))
);

export function reducer(state: RenewalState | undefined, action: RenewActionsUnion) {
  return renewalReducer(state, action);
}

function updateQuotedStatus(state: RenewalState, {isQuoted}: { isQuoted: boolean }): RenewalState {
  if (isQuoted && state.policyChangeSelection.options) {
    const {yourCar, yourMileage, yourRegistration, yourDrivers, yourAddresses, yourVehicleUsage, whereIParkMyCar, yourDetails} = state.policyChangeSelection.options;
    return {
      ...state,
      isQuoted,
      policyChangeSelectionLockedStatus: {yourCar, yourMileage, yourRegistration, yourDrivers, yourAddresses, yourVehicleUsage, whereIParkMyCar, yourDetails}
    };
  }
  return {...state, isQuoted};
}
